// src/scripts/components/specialty-page-init.js

import ReadMoreToggle from './readmore.js';

/**
 * Shared initializer for all specialty pages.
 * Safe to include in a shared bundle.
 */
export default function initSpecialtyPage() {
    if (window.__specialtyPageInitialized) return;
    window.__specialtyPageInitialized = true;

    const run = () => {
        if (!window.__readMoreInitialized) {
            window.__readMoreInitialized = true;
            new ReadMoreToggle();
        }

        const beginningButton = document.querySelector('.btn-beginning');
        if (beginningButton && beginningButton.dataset.scrollInit !== 'true') {
            beginningButton.dataset.scrollInit = 'true';

            beginningButton.addEventListener('click', (e) => {
                e.preventDefault();
                const faqsSection = document.getElementById('faqs');
                if (faqsSection) {
                    faqsSection.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
        run();
    }
}
